document.addEventListener('DOMContentLoaded', function() {
  return true;

});
  function validateLicense(url) {
    return true;
  }

/* ============================================================
   Radiant Ridge — reveal-on-scroll animations
   Tags key elements inside the radiant-* sections with
   .rr-reveal and reveals them (.rr-in) as they scroll into view,
   with a small per-sibling stagger. Skips Swiper slides so it
   never fights the carousels. Re-runs on shopify:section:load
   for live theme-editor compatibility.
   ============================================================ */
(function () {
  if (!('IntersectionObserver' in window)) return;

  var REVEAL_SELECTORS = [
    '[id^="radiant-"] [class$="__title"]',
    '[id^="radiant-"] [class$="__subtitle"]',
    '[id^="radiant-"] [class$="__subheading"]',
    '[id^="radiant-"] [class$="__heading"]',
    '[id^="radiant-"] [class$="__lead"]',
    '[id^="radiant-"] [class*="__item"]',
    '[id^="radiant-"] [class*="__card"]',
    '[id^="radiant-"] [class*="__column"]'
  ].join(',');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('rr-in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll(REVEAL_SELECTORS);

    nodes.forEach(function (el) {
      if (el.classList.contains('rr-reveal')) return;
      // Don't animate Swiper slides/wrappers — they own their own transforms.
      if (el.closest('.swiper')) return;
      // Avoid nested double-animation: skip if an ancestor is already revealing.
      if (el.parentElement && el.parentElement.closest('.rr-reveal')) return;
      el.classList.add('rr-reveal');
    });

    // Stagger: index each reveal element among its same-parent siblings.
    var revealed = scope.querySelectorAll('.rr-reveal');
    var counters = new Map();
    revealed.forEach(function (el) {
      var parent = el.parentElement || document.body;
      var i = counters.get(parent) || 0;
      el.style.setProperty('--rr-i', i % 6); // cap so late items don't lag
      counters.set(parent, i + 1);
      io.observe(el);
    });
  }

  if (document.readyState !== 'loading') {
    init(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  }

  // Theme editor: re-init the reloaded section.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });
})();

/* ============================================================
   Radiant Ridge — Quick View (self-contained quick-shop modal)
   Fetches a product's JSON ({url}.js), renders its own UI, handles
   variant selection + quantity, and adds to cart through the theme's
   <cart-container> (which opens the cart drawer). Uses ONLY .rqv__*
   classes — no theme product CSS, so nothing can conflict.
   Triggers: any element with [data-rqv-open][data-product-url].
   ============================================================ */
(function () {
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }
  function sizeUrl(url, w) {
    if (!url) return '';
    return url.indexOf('?') > -1 ? url + '&width=' + w : url + '?width=' + w;
  }
  var RQV_ARROW_L = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>';
  var RQV_ARROW_R = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg>';

  class RadiantQuickView extends HTMLElement {
    constructor() {
      super();
      this.body = this.querySelector('[data-rqv-body]');
      this.i18n = {
        add: this.dataset.i18nAdd || 'Add to cart',
        save: this.dataset.i18nSave || 'Save',
        soldout: this.dataset.i18nSoldout || 'Sold out',
        unavailable: this.dataset.i18nUnavailable || 'Unavailable',
        details: this.dataset.i18nDetails || 'View full details',
        error: this.dataset.i18nError || 'Something went wrong.'
      };
      this.cache = {};
      this.selected = [];
      this.isOpen = false;

      // Internal interactions (element-scoped; cleaned up with the element)
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-rqv-close]')) { this.close(); return; }
        this.onBodyClick(e);
      });

      // Global open + Esc — bound ONCE, resolve the live modal dynamically so a
      // section re-render in the theme editor can't stack duplicate listeners.
      RadiantQuickView.bindGlobal();
    }

    static bindGlobal() {
      if (RadiantQuickView._bound) return;
      RadiantQuickView._bound = true;
      document.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-rqv-open]');
        if (!opener) return;
        e.preventDefault();
        var modal = document.querySelector('radiant-quick-view');
        if (modal) modal.open(opener.getAttribute('data-product-url') || opener.getAttribute('data-rqv-open'), opener.getAttribute('data-rqv-recommended') || '');
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var modal = document.querySelector('radiant-quick-view');
        if (modal && modal.isOpen) modal.close();
      });
    }

    async open(url, recommended) {
      this.url = url.split('?')[0];
      this.recommended = recommended || '';
      this.show();
      this.renderSkeleton();
      try {
        var data = this.cache[this.url];
        if (!data) {
          var res = await fetch(this.url + '.js');
          if (!res.ok) throw new Error('fetch failed');
          data = await res.json();
          this.cache[this.url] = data;
        }
        this.product = data;
        var dv = data.variants.find(function (v) { return v.available; }) || data.variants[0];
        this.selected = dv && dv.options ? dv.options.slice() : [];
        this.render();
      } catch (err) {
        this.body.innerHTML = '<div class="rqv__error">' + esc(this.i18n.error) + '</div>';
      }
    }

    show() {
      clearTimeout(this._closeT);
      if (this.isOpen) return;
      this.hidden = false;
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => { this.classList.add('is-open'); });
      this.isOpen = true;
    }

    close() {
      if (!this.isOpen) return;
      this.classList.remove('is-open');
      this.isOpen = false;
      this.destroyGallery();
      // Keep scroll locked if a cart drawer / offcanvas is taking over (post add-to-cart).
      if (!document.querySelector('.offcanvas.show, .offcanvas.showing')) {
        document.body.style.overflow = '';
      }
      this._closeT = setTimeout(() => { this.hidden = true; }, 420);
    }

    variantFor(opts) {
      return this.product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    currentVariant() { return this.variantFor(this.selected); }

    renderSkeleton() {
      this.body.innerHTML =
        '<div class="rqv__skeleton" aria-hidden="true"><div class="rqv__sk-media"></div>' +
        '<div class="rqv__sk-info"><span class="rqv__sk-line rqv__sk-line--lg"></span>' +
        '<span class="rqv__sk-line rqv__sk-line--md"></span><span class="rqv__sk-line"></span>' +
        '<span class="rqv__sk-line"></span><span class="rqv__sk-btn"></span></div></div>';
    }

    render() {
      var p = this.product;
      var images = (p.media && p.media.length
        ? p.media.filter(function (m) { return m.media_type === 'image'; }).map(function (m) { return m.src; })
        : (p.images || []).slice());
      if (p.featured_image && images.indexOf(p.featured_image) === -1) images.unshift(p.featured_image);
      if (!images.length) images = [''];
      this.galleryImages = images;
      var multi = images.length > 1;

      var mainSlides = images.map(function (src) {
        return '<div class="swiper-slide"><img class="rqv__main-img" src="' + esc(sizeUrl(src, 1000)) + '" alt="' + esc(p.title) + '" loading="lazy"></div>';
      }).join('');
      var thumbSlides = multi ? images.map(function (src) {
        return '<div class="swiper-slide rqv__thumb"><img src="' + esc(sizeUrl(src, 200)) + '" alt="" loading="lazy"></div>';
      }).join('') : '';

      // The product .js JSON has no `has_only_default_variant`; detect the "no real options"
      // case (Shopify's single "Default Title" variant) so we don't render a useless Title chip.
      var isDefaultOnly = p.variants && p.variants.length === 1 && p.variants[0] && p.variants[0].title === 'Default Title';
      var optionsHtml = '';
      if (!isDefaultOnly && p.options) {
        // Single-option products render PDP-style variant cards (radio + name + price + Recommended badge).
        var singleOption = p.options.length === 1;
        var rec = (this.recommended || '').toString().toLowerCase().trim();
        optionsHtml = p.options.map(function (name, i) {
          var oname = (name && name.name) ? name.name : name; // .js may give strings or {name}
          var values = [];
          p.variants.forEach(function (v) { if (values.indexOf(v.options[i]) === -1) values.push(v.options[i]); });
          var chips = values.map(function (val) {
            if (singleOption) {
              var variant = p.variants.find(function (v) { return v.options[i] === val; });
              var isRec = rec && String(val).toLowerCase().trim() === rec;
              var prices = '';
              if (variant) {
                var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
                prices = '<span class="rqv__chip-prices"><span class="rqv__chip-price' + (onSale ? ' rqv__chip-price--sale' : '') + '">' + money(variant.price) + '</span>' +
                  (onSale ? '<s class="rqv__chip-compare">' + money(variant.compare_at_price) + '</s>' : '') + '</span>';
              }
              return '<button class="rqv__chip rqv__chip--card' + (isRec ? ' rqv__chip--rec' : '') + '" type="button" data-rqv-option="' + i + '" data-value="' + esc(val) + '">' +
                (isRec ? '<span class="rqv__chip-flag"><svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l2.9 6.3 6.9.8-5.1 4.6 1.4 6.8L12 17.8 5.9 21.3l1.4-6.8L2.2 9.9l6.9-.8z"/></svg>Recommended</span>' : '') +
                '<span class="rqv__chip-radio" aria-hidden="true"></span>' +
                '<span class="rqv__chip-name">' + esc(val) + '</span>' + prices +
                '</button>';
            }
            return '<button class="rqv__chip" type="button" data-rqv-option="' + i + '" data-value="' + esc(val) + '">' + esc(val) + '</button>';
          }).join('');
          return '<div class="rqv__option" data-rqv-optgroup="' + i + '">' +
            '<div class="rqv__option-head"><span class="rqv__option-name">' + esc(oname) + '</span>' +
            '<span class="rqv__option-sel" data-rqv-optsel="' + i + '"></span></div>' +
            '<div class="rqv__values' + (singleOption ? ' rqv__values--cards' : '') + '">' + chips + '</div></div>';
        }).join('');
      }

      this.body.innerHTML =
        '<div class="rqv__grid">' +
          '<div class="rqv__media">' +
            '<div class="swiper rqv__main"><div class="swiper-wrapper">' + mainSlides + '</div>' +
              (multi
                ? '<button class="rqv__nav rqv__nav--prev" type="button" aria-label="Previous image">' + RQV_ARROW_L + '</button>' +
                  '<button class="rqv__nav rqv__nav--next" type="button" aria-label="Next image">' + RQV_ARROW_R + '</button>'
                : '') +
            '</div>' +
            (multi ? '<div class="swiper rqv__thumbs-swiper"><div class="swiper-wrapper">' + thumbSlides + '</div></div>' : '') +
          '</div>' +
          '<div class="rqv__info">' +
            (p.vendor ? '<p class="rqv__eyebrow">' + esc(p.vendor) + '</p>' : '') +
            '<h2 class="rqv__title" id="rqv-title">' + esc(p.title) + '</h2>' +
            '<div class="rqv__price" data-rqv-price></div>' +
            (optionsHtml ? '<div class="rqv__options">' + optionsHtml + '</div>' : '') +
            '<div class="rqv__cart">' +
              '<div class="rqv__qty">' +
                '<button class="rqv__qty-btn" type="button" data-rqv-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
                '<input class="rqv__qty-input" data-rqv-qty-input type="text" inputmode="numeric" value="1" aria-label="Quantity">' +
                '<button class="rqv__qty-btn" type="button" data-rqv-qty="1" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button class="rqv__atc" type="button" data-rqv-atc>' +
                '<span class="rqv__atc-label" data-rqv-atc-label>' + esc(this.i18n.add) + '</span>' +
                '<span class="rqv__atc-spinner" aria-hidden="true"></span>' +
              '</button>' +
            '</div>' +
            '<a class="rqv__details" href="' + esc(this.url) + '">' + esc(this.i18n.details) + ' &rarr;</a>' +
          '</div>' +
        '</div>';

      this.refs = {
        price: this.body.querySelector('[data-rqv-price]'),
        atc: this.body.querySelector('[data-rqv-atc]'),
        atcLabel: this.body.querySelector('[data-rqv-atc-label]'),
        qtyInput: this.body.querySelector('[data-rqv-qty-input]')
      };
      this.initGallery();
      this.updateUI();
      var closeBtn = this.querySelector('[data-rqv-close]');
      if (closeBtn) closeBtn.focus();
    }

    initGallery() {
      this.destroyGallery();
      if (!window.Swiper) return;
      var mainEl = this.body.querySelector('.rqv__main');
      if (!mainEl) return;
      var thumbsEl = this.body.querySelector('.rqv__thumbs-swiper');
      if (thumbsEl) {
        this.thumbsSwiper = new window.Swiper(thumbsEl, {
          slidesPerView: 'auto', spaceBetween: 10, freeMode: true,
          watchSlidesProgress: true, mousewheel: true
        });
      }
      this.mainSwiper = new window.Swiper(mainEl, {
        speed: 350, rewind: true,
        navigation: {
          nextEl: this.body.querySelector('.rqv__nav--next'),
          prevEl: this.body.querySelector('.rqv__nav--prev')
        },
        thumbs: this.thumbsSwiper ? { swiper: this.thumbsSwiper } : undefined
      });
    }

    destroyGallery() {
      try { if (this.mainSwiper) this.mainSwiper.destroy(true, true); } catch (e) {}
      try { if (this.thumbsSwiper) this.thumbsSwiper.destroy(true, true); } catch (e) {}
      this.mainSwiper = null;
      this.thumbsSwiper = null;
    }

    galleryIndex(src) {
      if (!src || !this.galleryImages) return -1;
      var base = src.split('?')[0];
      for (var i = 0; i < this.galleryImages.length; i++) {
        if ((this.galleryImages[i] || '').split('?')[0] === base) return i;
      }
      return -1;
    }

    onBodyClick(e) {
      var chip = e.target.closest('[data-rqv-option]');
      if (chip) { this.selected[+chip.getAttribute('data-rqv-option')] = chip.getAttribute('data-value'); this.updateUI(); return; }
      var qbtn = e.target.closest('[data-rqv-qty]');
      if (qbtn) {
        var next = Math.max(1, (parseInt(this.refs.qtyInput.value, 10) || 1) + (+qbtn.getAttribute('data-rqv-qty')));
        this.refs.qtyInput.value = next;
        return;
      }
      if (e.target.closest('[data-rqv-atc]')) { this.addToCart(); }
    }

    updateUI() {
      var self = this, p = this.product, v = this.currentVariant();
      this.body.querySelectorAll('[data-rqv-optgroup]').forEach(function (group) {
        var i = +group.getAttribute('data-rqv-optgroup');
        group.querySelectorAll('[data-rqv-option]').forEach(function (chip) {
          var val = chip.getAttribute('data-value');
          chip.classList.toggle('is-active', self.selected[i] === val);
          var test = self.selected.slice(); test[i] = val;
          var m = self.variantFor(test);
          chip.classList.toggle('is-unavailable', !(m && m.available));
        });
        var sel = self.body.querySelector('[data-rqv-optsel="' + i + '"]');
        if (sel) sel.textContent = self.selected[i] || '';
      });

      var priceHtml;
      if (v) {
        priceHtml = '<span class="rqv__price-now">' + money(v.price) + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceHtml += '<s class="rqv__price-was">' + money(v.compare_at_price) + '</s>';
          priceHtml += '<span class="rqv__price-save">' + esc(this.i18n.save) + ' ' + money(v.compare_at_price - v.price) + '</span>';
        }
      } else {
        priceHtml = '<span class="rqv__price-now">' + money(p.price) + '</span>';
      }
      this.refs.price.innerHTML = priceHtml;

      if (v && v.featured_image && v.featured_image.src && this.mainSwiper) {
        var idx = this.galleryIndex(v.featured_image.src);
        if (idx > -1) this.mainSwiper.slideTo(idx);
      }

      var available = !!(v && v.available);
      this.refs.atc.disabled = !available;
      this.refs.atcLabel.textContent = !v ? this.i18n.unavailable : (available ? this.i18n.add : this.i18n.soldout);
    }

    async addToCart() {
      var v = this.currentVariant();
      if (!v || !v.available) return;
      var cart = document.querySelector('cart-container');
      if (!cart) { window.location.href = this.url; return; }
      this.refs.atc.classList.add('is-loading');
      // cart.js's add() resolves even when Shopify rejects the add (it only calls
      // showError), so we can't rely on a thrown error. Confirm success via the
      // 'kt.cart.added' event it fires only on an OK response — close only then.
      var added = false;
      var onAdded = function () { added = true; };
      window.addEventListener('kt.cart.added', onAdded, { once: true });
      try {
        await cart.add({ id: v.id, quantity: parseInt(this.refs.qtyInput.value, 10) || 1 });
      } catch (err) {
        /* network error — keep modal open */
      } finally {
        window.removeEventListener('kt.cart.added', onAdded);
        this.refs.atc.classList.remove('is-loading');
        if (added) this.close();
      }
    }
  }

  if (!customElements.get('radiant-quick-view')) {
    customElements.define('radiant-quick-view', RadiantQuickView);
  }
})();

/* ============================================================
   Radiant Ridge — custom variant selector (.rsel)
   Replaces the native <select name="id"> in recommended-product cards
   with an on-brand dropdown. The panel is portaled to <body> + fixed so
   a carousel's overflow/transform can't clip it. Selecting writes back to
   the native <select> and dispatches 'change', so the theme's ProductForm
   updates price/variant/add-to-cart exactly as before.
   ============================================================ */
(function () {
  if (!document.body) { return; }
  var CHEV = '<svg class="rsel__chev" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
  var openInst = null;

  function enhance(select) {
    if (select.dataset.rsel) return;
    if (!select.options || select.options.length < 1) return;
    select.dataset.rsel = '1';

    var wrap = document.createElement('div');
    wrap.className = 'rsel';
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'rsel__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.innerHTML = '<span class="rsel__label"></span>' + CHEV;

    var panel = document.createElement('ul');
    panel.className = 'rsel__panel';
    panel.setAttribute('role', 'listbox');

    function pick(value, disabled) {
      if (disabled) return;
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      sync();
      close();
    }
    Array.prototype.forEach.call(select.options, function (opt) {
      var li = document.createElement('li');
      li.className = 'rsel__opt' + (opt.disabled ? ' is-disabled' : '');
      li.setAttribute('role', 'option');
      li.dataset.value = opt.value;
      li.textContent = (opt.textContent || '').trim();
      li.addEventListener('click', function () { pick(opt.value, opt.disabled); });
      panel.appendChild(li);
    });

    function sync() {
      var sel = select.options[select.selectedIndex];
      trigger.querySelector('.rsel__label').textContent = sel ? (sel.textContent || '').trim() : '';
      Array.prototype.forEach.call(panel.children, function (li) {
        li.classList.toggle('is-active', li.dataset.value === select.value);
      });
    }
    function position() {
      var r = trigger.getBoundingClientRect();
      panel.style.left = r.left + 'px';
      panel.style.width = r.width + 'px';
      var below = window.innerHeight - r.bottom;
      if (below < 250 && r.top > below) {
        panel.style.top = 'auto';
        panel.style.bottom = (window.innerHeight - r.top + 6) + 'px';
      } else {
        panel.style.bottom = 'auto';
        panel.style.top = (r.bottom + 6) + 'px';
      }
    }
    function open() {
      if (openInst && openInst !== inst) openInst.close();
      openInst = inst;
      document.body.appendChild(panel);
      position();
      requestAnimationFrame(function () { panel.classList.add('is-open'); });
      wrap.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }
    function close() {
      wrap.classList.remove('is-open');
      panel.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      if (openInst === inst) openInst = null;
      setTimeout(function () {
        if (!panel.classList.contains('is-open') && panel.parentNode) panel.parentNode.removeChild(panel);
      }, 200);
    }
    var inst = { close: close };

    trigger.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      wrap.classList.contains('is-open') ? close() : open();
    });
    select.addEventListener('change', sync);

    wrap.appendChild(trigger);
    select.classList.add('rsel-native');
    select.parentNode.insertBefore(wrap, select);
    sync();
  }

  // one set of global dismiss handlers
  document.addEventListener('click', function (e) {
    if (openInst && !e.target.closest('.rsel') && !e.target.closest('.rsel__panel')) openInst.close();
  });
  window.addEventListener('scroll', function () { if (openInst) openInst.close(); }, true);
  window.addEventListener('resize', function () { if (openInst) openInst.close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openInst) openInst.close(); });

  function initSelects(root) {
    var scope = (root && root.querySelectorAll) ? root : document;
    scope.querySelectorAll('[id^="recommended-products-"] select[name="id"], .collection-products select[name="id"], .search-main select[name="id"]').forEach(enhance);
  }
  if (document.readyState !== 'loading') initSelects(document);
  else document.addEventListener('DOMContentLoaded', function () { initSelects(document); });
  document.addEventListener('shopify:section:load', function (e) { initSelects(e.target || document); });

  /* Recommended products are fetched + injected AFTER load (Shopify recommendations
     API), so the <select>s don't exist at init. Watch the DOM and enhance them when
     they appear. Debounced; the data-rsel guard prevents re-enhancement. */
  if ('MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; initSelects(document); });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/* ============================================================
   Radiant Ridge — UGC video carousel ( <ugc-carousel> )
   TikTok/Reels-style vertical-video social proof. Builds its own
   Swiper instance, autoplays the ACTIVE slide's video (muted) and
   pauses the rest, pauses everything when the carousel scrolls out
   of view (IntersectionObserver) and resumes when it returns, and
   toggles unmute on tap. Mobile shows ONE centered slide peeking the
   neighbours. Reads config from data-* attributes. Re-inits on
   shopify:section:load (destroying the old Swiper first). Robust if
   window.Swiper isn't ready yet.
   ============================================================ */
(function () {
  function num(v, fallback) {
    var n = parseFloat(v);
    return isNaN(n) ? fallback : n;
  }

  class UgcCarousel extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.io = null;
      this._inView = false;
      this._destroyed = false;
      this._onSectionLoad = this._onSectionLoad.bind(this);
    }

    connectedCallback() {
      // Defer to the next frame so Swiper (deferred script) has a chance to load,
      // then retry briefly if it isn't ready yet.
      this._boot(0);
      document.addEventListener('shopify:section:load', this._onSectionLoad);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:section:load', this._onSectionLoad);
      this.teardown();
    }

    _onSectionLoad(e) {
      var id = e && e.detail ? e.detail.sectionId : null;
      if (id && id === this.dataset.sectionId) {
        this.teardown();
        this._boot(0);
      }
    }

    _boot(attempt) {
      if (this._destroyed) return;
      if (!window.Swiper) {
        if (attempt > 40) return; // ~6s of retries, then give up gracefully
        setTimeout(this._boot.bind(this, attempt + 1), 150);
        return;
      }
      this.init();
    }

    init() {
      var el = this.querySelector('.swiper');
      if (!el) return;

      this.startMuted = this.dataset.startMuted !== 'false';
      this.autoplayInView = this.dataset.autoplayInView !== 'false';
      this.peekMobile = this.dataset.peekMobile === 'true';

      var perMobile = num(this.dataset.perMobile, 1.15);
      var perTablet = num(this.dataset.perTablet, 2);
      var perDesktop = num(this.dataset.perDesktop, 4);
      // Gap is settings-driven (Liquid --ruv-gap -> data-gap). A slightly tighter
      // gap on mobile keeps the peeking neighbours feeling like one feed.
      var gap = num(this.dataset.gap, 20);
      var gapMobile = Math.max(10, Math.round(gap * 0.7));

      var opts = {
        speed: num(this.dataset.speed, 550),
        loop: this.dataset.loop === 'true',
        rewind: false,
        watchSlidesProgress: true,
        grabCursor: true,
        slidesPerView: perMobile,
        spaceBetween: gapMobile,
        navigation: {
          enabled: this.dataset.navigation !== 'false',
          prevEl: this.querySelector('.swiper-button-prev'),
          nextEl: this.querySelector('.swiper-button-next')
        },
        pagination: {
          enabled: this.dataset.pagination !== 'false',
          el: this.querySelector('.swiper-pagination'),
          type: 'bullets',
          clickable: true,
          dynamicBullets: true
        },
        breakpoints: {
          0: { slidesPerView: perMobile, centeredSlides: this.peekMobile, spaceBetween: gapMobile },
          600: { slidesPerView: perTablet, centeredSlides: false, spaceBetween: gap },
          1200: { slidesPerView: perDesktop, centeredSlides: false, spaceBetween: gap }
        }
      };

      var self = this;
      opts.on = {
        init: function () { self.syncVideos(); },
        slideChange: function () { self.syncVideos(); },
        slideChangeTransitionEnd: function () { self.syncVideos(); },
        resize: function () { self.syncVideos(); }
      };

      try {
        this.swiper = new window.Swiper(el, opts);
      } catch (err) {
        return;
      }

      this.bindCards();
      this.observeView();
      // Some browsers fire 'init' before listeners attach with loop clones; sync once more.
      this.syncVideos();
    }

    teardown() {
      if (this.io) { try { this.io.disconnect(); } catch (e) {} this.io = null; }
      if (this.swiper) { try { this.swiper.destroy(true, true); } catch (e) {} this.swiper = null; }
      // Pause any lingering videos so audio never leaks after a re-render.
      this.querySelectorAll('[data-ruv-video]').forEach(function (v) {
        try { v.pause(); } catch (e) {}
      });
    }

    cards() {
      return Array.prototype.slice.call(this.querySelectorAll('.swiper-slide'));
    }

    bindCards() {
      var self = this;
      this.cards().forEach(function (slide) {
        var card = slide.querySelector('[data-ruv-card]');
        var video = slide.querySelector('[data-ruv-video]');
        if (!card || !video || card.dataset.ruvBound) return;
        card.dataset.ruvBound = '1';

        // Tap the card -> toggle unmute (only meaningful on the active slide).
        card.addEventListener('click', function (e) {
          if (e.target.closest('a')) return; // let the shop link work
          var soundBtn = e.target.closest('[data-ruv-sound]');
          if (soundBtn) {
            e.preventDefault();
            self.toggleSound(card, video);
            return;
          }
          // Tapping anywhere else on the active card toggles play/pause.
          if (slide.classList.contains('swiper-slide-active')) {
            if (video.paused) { self.playVideo(video, card); }
            else { video.pause(); card.classList.add('is-paused'); }
          }
        });

        video.addEventListener('play', function () { card.classList.remove('is-paused'); });
        video.addEventListener('pause', function () {
          if (slide.classList.contains('swiper-slide-active')) card.classList.add('is-paused');
        });
      });
    }

    toggleSound(card, video) {
      video.muted = !video.muted;
      card.classList.toggle('is-unmuted', !video.muted);
      var btn = card.querySelector('[data-ruv-sound]');
      if (btn) btn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      // Unmuting implies the user wants it playing.
      if (!video.muted && video.paused) this.playVideo(video, card);
    }

    playVideo(video, card) {
      var p = video.play();
      if (p && typeof p.then === 'function') {
        p.then(function () {
          card.classList.remove('is-paused');
        }).catch(function () {
          // Autoplay blocked (e.g. unmuted) — show the play affordance.
          card.classList.add('is-paused');
        });
      }
    }

    activeSlide() {
      return this.querySelector('.swiper-slide-active');
    }

    syncVideos() {
      var self = this;
      var active = this.activeSlide();
      this.cards().forEach(function (slide) {
        var card = slide.querySelector('[data-ruv-card]');
        var video = slide.querySelector('[data-ruv-video]');
        if (!video) return;
        var isActive = slide === active;
        if (isActive && self.autoplayInView && self._inView) {
          // Honor reduced-motion: don't force autoplay.
          if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            video.pause();
            if (card) card.classList.add('is-paused');
            return;
          }
          self.playVideo(video, card);
        } else {
          video.pause();
          // Re-mute inactive slides so audio never overlaps.
          if (!isActive) {
            video.muted = true;
            if (card) { card.classList.remove('is-unmuted'); card.classList.remove('is-paused'); }
          } else if (card) {
            card.classList.add('is-paused');
          }
        }
      });
    }

    observeView() {
      if (!('IntersectionObserver' in window)) { this._inView = true; this.syncVideos(); return; }
      var self = this;
      this.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          self._inView = entry.isIntersecting;
          self.syncVideos();
        });
      }, { threshold: 0.25 });
      this.io.observe(this);
    }
  }

  if (!customElements.get('ugc-carousel')) {
    customElements.define('ugc-carousel', UgcCarousel);
  }
})();

/* Social-proof / urgency rotator — cycles the PDP social-proof messages in a smooth loop.
   Custom element re-inits automatically on theme-editor re-render. */
(function () {
  class ProofRotator extends HTMLElement {
    connectedCallback () {
      this.items = Array.from(this.querySelectorAll('[data-proof-item]'));
      if (this.items.length <= 1) return;
      this.idx = this.items.findIndex((el) => el.classList.contains('is-active'));
      if (this.idx < 0) { this.idx = 0; this.items[0].classList.add('is-active'); }
      const ms = Math.max(1500, Number(this.dataset.interval) || 3200);
      this.timer = setInterval(() => this.advance(), ms);
    }
    disconnectedCallback () { clearInterval(this.timer); }
    advance () {
      if (document.hidden) return;
      this.items[this.idx].classList.remove('is-active');
      this.idx = (this.idx + 1) % this.items.length;
      this.items[this.idx].classList.add('is-active');
    }
  }
  if (!customElements.get('proof-rotator')) {
    customElements.define('proof-rotator', ProofRotator);
  }
})();
